import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { RequestProvider } from '../../../../context/RequestContext'
import { s3Static } from '../../../../utils/constants'
import { Services } from '../../service/Services'
import { openModal } from '../../../../service/modal-service'
import { AnimatePresence, motion } from 'framer-motion'
import { HandymanBooking } from './HandymanBooking'
import { useRouter } from 'next/router'
import { HandymanDealItems } from './HandymanDealItems'
import { StickyCta } from '@/commons/service-hub/StickyCta'

export const HandymanServiceRequestFormSlug = (props) => {
    const router = useRouter() 
    const countryName = props.countryName
    const requestCategorySettings = props.requestCategorySettings
    const requestType = "Handyman Services"
    const handymanPriceList = props.handymanPriceList
    const post = props.post
    
    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isShowDealItems, setIsShowDealItems ] = useState(false)

    // Handyman bookings always start from the priced job picker, never the
    // question wizard (which lacks most jobs and their details). A
    // ?requestForm=true link opens the picker.
    useEffect(() => {
        if (router.query.requestForm) setIsShowDealItems(true)
    }, [router.query.requestForm])

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        // setRequestForm(true)
        openModal(setRequestForm)
    }

    const videoRef = useRef();
    
    useEffect(() => {  
        videoRef.current.play()
    }, [])

  return (
    <section id="handyman-service" className='relative'>
        <div className="-mt-14 relative w-full aspect-video sm:h-180 overflow-hidden">
            {/* Media Layer */}
            <div className="absolute inset-0 w-full h-full">

                {/* Mobile Video */}
                <video
                ref={videoRef}
                className="absolute inset-0 w-full h-full object-cover sm:hidden"
                poster={s3Static + "handyman/chinese-handyman-with-hammer.jpg"}
                title="Handyman Singapore"
                muted
                loop
                playsInline
                preload="metadata"
                >
                <source src="/video/handyman-1080p-least-quality-with-music.mp4" />
                <source src="/video/handyman-1080p-least-quality-with-music.mov" />
                </video>

                {/* Desktop Animated Image */}
                <motion.div
                className="hidden sm:block absolute inset-0"
                initial={{ x: "0%", y: "0%", scale: 1 }}
                animate={{
                    x: ["0%", "2%", "-2%", "2%", "-2%", "2%", "0%"],
                    y: ["0%", "-2%", "2%", "2%", "-2%", "-2%", "0%"],
                    scale: [1, 1.05, 1.1, 1.15, 1.1, 1.05, 1],
                }}
                transition={{ repeat: Infinity, duration: 90 }}
                >
                <Image
                    src={post.featuredImage?.node?.sourceUrl ?? s3Static + "logo.png"}
                    fill
                    className="object-cover"
                    alt={post.title}
                    priority
                    sizes="100vw"
                />
                </motion.div>
            </div>
        </div>       
        <RequestProvider>
            <div id="campaign" className='relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2'>
                <HandymanBooking requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} handymanType="Handyman"
                    setIsQuickBook={setIsQuickBook} countryName={countryName} setIsShowDealItems={setIsShowDealItems}
                    handymanPriceList={handymanPriceList}/>
            </div>                          
            {isShowDealItems &&
                <AnimatePresence>
                    <HandymanDealItems requestCategorySettings={requestCategorySettings} handymanPriceList={handymanPriceList} setRequestForm={setRequestForm} setIsQuickBook={setIsQuickBook} openRequestForm={openRequestForm} setIsShowDealItems={setIsShowDealItems}/> 
                </AnimatePresence>
            }    
            {requestForm &&
                <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
            }
        </RequestProvider>
        {/* Book Now opens the job picker, like the hubs. This bar used to open
            the question wizard. */}
        {!requestForm && !isShowDealItems &&
            <StickyCta onBook={() => setIsShowDealItems(true)} whatsAppText="Hi, I'd like to book a handyman."/>
        }
    </section>
  )
}